export default "__VITE_ASSET__Bh3HGOek__"